import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import IconButton from '@mui/material/IconButton';
import { useDeadline } from "../../../contexts/DeadlineContext";
const AbstractHomePAgeSettings = () => {
    const history = useHistory();
    const { fetchHomeSetupData } = useDeadline();

    const eventid = localStorage.getItem('eventid');
    const [disabled, setdisabled] = useState(false);
    const [abstractBannerImage, setAbstractBannerImage] = useState("");
    const [workshopBannerImage, setWokshopBannerImage] = useState("");
    const [conferenceBannerImage, setConfereceBannerImage] = useState("");
    const [eventLogo, setEventLogo] = useState("");
    const [abstractFooterImage, setAbstractFooterImage] = useState("");
    const [abstractSponserLogos, setAbstractSponserLogos] = useState("");
    const [abstractEndDate, setAbstractEndDate] = useState('');
    const [abstractEndTime, setAbstractEndTime] = useState('');
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        color_code_four: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        workshopBannerImage: "",
        conferenceBannerImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        online_status: "",
        bank_status: "",
        cash_status: "",
        free_status: "",
        c_online_status: "",
        c_group_registration: "",
        c_bank_status: "",
        c_bank_details: "",
        c_cash_status: "",
        
        c_free_status: "",
        c_saudi_council_status: "",
        eventLogo: "",
        error_list: [],
    });
    const [serverAwsS3error, setServerAwsS3error] = useState("");


    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                const fieldError = res.data.fieldErrors;
                setAbstractHomeSetup(getHomePageData);
                setServerAwsS3error(fieldError);
                // Parse the JSON string for abstractSponserLogos
                try {
                    const parsedLogos = getHomePageData.abstractSponserLogos ? JSON.parse(getHomePageData.abstractSponserLogos) : [];
                    setAbstractSponserLogos(parsedLogos);
                } catch (e) {
                    console.error("Error parsing abstractSponserLogos:", e);
                    setAbstractSponserLogos([]);
                }
            }
        });
    }, [eventid]);

    //this is for Storage Server error
    const hasFieldErrors = serverAwsS3error && Object.keys(serverAwsS3error).length > 0;

    const handleInput = (e) => {
        const { name, value } = e.target;
        setAbstractHomeSetup(prevState => ({
            ...prevState,
            [name]: value
        }));
    };
    const handleAnstractEndDateChange = (event) => {
        const newDate = event.target.value;
        setAbstractEndDate(newDate);
        setAbstractHomeSetup(prevState => ({
            ...prevState,
            abstractEndDate: newDate
        }));
    };


    const handleAbstractEndTime = (event) => {
        const newTime = event.target.value;
        setAbstractEndTime(newTime);
        setAbstractHomeSetup(prevState => ({
            ...prevState,
            abstractEndTime: newTime
        }));
    };
    const handleBannerChange = (e) => {
        setAbstractBannerImage(e.target.files[0]);
    };
    const handleWorkshopBannerChange = (e) => {
        setWokshopBannerImage(e.target.files[0]);
    };


    const handleFileChange = (e) => {
        setAbstractSponserLogos(Array.from(e.target.files));
    };



    // console.log(abstractHomeSetup)

    const homePageSubmit = (e) => {
        e.preventDefault();
        const data = {
            color_code: abstractHomeSetup.color_code,
            color_code_two: abstractHomeSetup.color_code_two,
            color_code_three: abstractHomeSetup.color_code_three,
            color_code_four: abstractHomeSetup.color_code_four,

            call_emergency: abstractHomeSetup.call_emergency,
            send_email: abstractHomeSetup.send_email,
            event_place: abstractHomeSetup.event_place,
            eventid,
            abstractBannerImage,
            abstractSponserLogos,
            abstractFooterImage,
            workshopBannerImage,
            conferenceBannerImage,
            eventLogo,

            online_status: abstractHomeSetup.online_status,
            bank_status: abstractHomeSetup.bank_status,
            cash_status: abstractHomeSetup.cash_status,
            free_status: abstractHomeSetup.free_status,

            c_group_registration: abstractHomeSetup.c_group_registration,
            c_online_status: abstractHomeSetup.c_online_status,
            c_bank_status: abstractHomeSetup.c_bank_status,
            c_bank_details: abstractHomeSetup.c_bank_details,
            c_cash_status: abstractHomeSetup.c_cash_status,
            c_free_status: abstractHomeSetup.c_free_status,
            c_saudi_council_status: abstractHomeSetup.c_saudi_council_status,

            facebook_link: abstractHomeSetup.facebook_link,
            Instagram_link: abstractHomeSetup.Instagram_link,
            linkedin_link: abstractHomeSetup.linkedin_link,
            twitter_link: abstractHomeSetup.twitter_link,

        };



        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/add-home-setup`, data, config).then(res => {
                if (res.data.status === 200) {
                    //localStorage.setItem('isActives', 1);
                    //fetchHomeSetupData();
                    swal('Success', res.data.message, 'success');
                    // history.push('/admin/exhibition/booth');

                    axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
                        if (res.status === 200) {
                            const getHomePageData = res.data.HomePageSetup;
                            setAbstractHomeSetup(getHomePageData);
                            // Parse the JSON string for abstractSponserLogos
                            try {
                                const parsedLogos = getHomePageData.abstractSponserLogos ? JSON.parse(getHomePageData.abstractSponserLogos) : [];
                                setAbstractSponserLogos(parsedLogos);
                            } catch (e) {
                                console.error("Error parsing abstractSponserLogos:", e);
                                setAbstractSponserLogos([]);
                            }

                        }
                    })


                }
                else {
                    setAbstractHomeSetup({ ...abstractHomeSetup, error_list: res.data.validate_error })
                }
            });
        });


    }
    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }} >
                    <Button sx={{
                        float: 'right',
                        marginTop: '2%',
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'
                        onClick={() => history.goBack()}>
                        BAck
                    </Button>
                </h4>
                <Card sx={{ width: '60vw', float: 'center' }} >
                    <CardContent >
                        <Typography component="h1" variant="h5">
                            Home Page Settings
                        </Typography>
                        {hasFieldErrors && (
                            <Grid item xs={8}>
                                <div style={{ color: 'red', textAlign: 'center', margin: '20px 0' }}>
                                    There are AWS S3 server issues affecting some fields. Please check!
                                </div>
                            </Grid>
                        )}
                        <Box component="form" onSubmit={homePageSubmit} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Header And Footer Background Color code"
                                        autoFocus
                                        value={abstractHomeSetup.color_code || ""}
                                        name='color_code' onChange={handleInput}
                                    />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Form Background Color code"
                                        autoFocus
                                        value={abstractHomeSetup.color_code_four || ""}
                                        name='color_code_four' onChange={handleInput}
                                    />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Button Background Color Code"
                                        autoFocus
                                        value={abstractHomeSetup.color_code_two || ""}
                                        name='color_code_two' onChange={handleInput}
                                    />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Footer Background Color Code"
                                        autoFocus
                                        value={abstractHomeSetup.color_code_three || ""}
                                        name='color_code_three' onChange={handleInput}
                                    />
                                </Grid>

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Event Place"
                                        autoFocus
                                        value={abstractHomeSetup.event_place || ""}
                                        name='event_place' onChange={handleInput}
                                    />
                                </Grid>

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Send Email"
                                        autoFocus
                                        value={abstractHomeSetup.send_email || ""}
                                        name='send_email' onChange={handleInput}
                                    />
                                </Grid>

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Call Emergency"
                                        autoFocus
                                        name='call_emergency' onChange={handleInput}
                                        value={abstractHomeSetup.call_emergency || ""}
                                    />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="FaceBook icone Link"
                                        autoFocus
                                        name='facebook_link' onChange={handleInput}
                                        value={abstractHomeSetup.facebook_link || ""}
                                    />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Instagram icone Link"
                                        autoFocus
                                        name='Instagram_link' onChange={handleInput}
                                        value={abstractHomeSetup.Instagram_link || ""}
                                    />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="LinkedIn icone Link"
                                        autoFocus
                                        name='linkedin_link' onChange={handleInput}
                                        value={abstractHomeSetup.linkedin_link || ""}
                                    />
                                </Grid>
                                <Grid item xs={12} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Twitter icone Link"
                                        autoFocus
                                        name='twitter_link' onChange={handleInput}
                                        value={abstractHomeSetup.twitter_link || ""}
                                    />
                                </Grid>

                                <Grid item xs={6} >
                                    <TextField
                                        id="date"
                                        fullWidth
                                        label="Abstract End Date"
                                        type="date"
                                        value={abstractHomeSetup.abstractEndDate || ""}
                                        onChange={handleAnstractEndDateChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        id="time"
                                        label="Abstract End Time"
                                        type="time"
                                        fullWidth
                                        value={abstractHomeSetup.abstractEndTime ? abstractHomeSetup.abstractEndTime.substring(0, 5) : ""}
                                        onChange={handleAbstractEndTime}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        inputProps={{
                                            step: 300, // 5 minutes interval
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Abstract Registration Status</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Abstract Registration Status"
                                            name="abstract_deadline_status" // Ensure this matches the property name in your state
                                            value={abstractHomeSetup.abstract_deadline_status || "0"}
                                            onChange={handleInput}>
                                            <MenuItem value={1} >Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Workshop Online Status</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Workshop Online Status "
                                            name="online_status" // Ensure this matches the property name in your state
                                            value={abstractHomeSetup.online_status || "0"}
                                            onChange={handleInput}>
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>


                                <Grid item xs={6} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Workshop Bank Status</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Workshop Bank Status "
                                            name="bank_status" // Ensure this matches the property name in your state
                                            value={abstractHomeSetup.bank_status || "0"}
                                            onChange={handleInput}>
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} >
                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Workshop Cash Status</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Workshop Cash Status "
                                            name="cash_status" // Ensure this matches the property name in your state
                                            value={abstractHomeSetup.cash_status || "0"}
                                            onChange={handleInput}>
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Workshop Free Status</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Workshop Free Status"
                                            name="free_status" // Ensure this matches the property name in your state
                                            value={abstractHomeSetup.free_status || "0"}
                                            onChange={handleInput}>
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>


                                {/* confernce Buttont */}

                                <Grid item xs={6} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Confernce Group Registration</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Confernce Group Registration"
                                            name="c_group_registration" // Ensure this matches the property name in your state
                                            value={abstractHomeSetup.c_group_registration || "0"}
                                            onChange={handleInput}>
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={6} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Confernce Online Status</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Confernce Online Status "
                                            name="c_online_status" // Ensure this matches the property name in your state
                                            value={abstractHomeSetup.c_online_status || "0"}
                                            onChange={handleInput}>
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>


                                <Grid item xs={6} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Confernce Bank Status</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Confernce Bank Status "
                                            name="c_bank_status" // Ensure this matches the property name in your state
                                            value={abstractHomeSetup.c_bank_status || "0"}
                                            onChange={handleInput}>
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>

                                    {abstractHomeSetup.c_bank_status === 1 && (
                                        <TextField
                                            label="Bank Details .. Example: Bank Name, Account Number, IBAN"
                                            name="c_bank_details"
                                            value={abstractHomeSetup.c_bank_details || ""}
                                            onChange={handleInput}
                                            multiline
                                            minRows={3}
                                            fullWidth
                                            margin="normal"
                                        />
                                    )}
                                    {/* {parseInt(abstractHomeSetup.c_bank_status) === 1 && (
                                        <TextField
                                            label="Bank Details"
                                            name="c_bank_details"
                                            value={abstractHomeSetup.c_bank_details || ""}
                                            onChange={handleInput}
                                            multiline
                                            rows={4}
                                            fullWidth
                                            margin="normal"
                                        />
                                    )} */}
                                </Grid>
                                <Grid item xs={6} >
                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Confernce Cash Status</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Confernce Cash Status "
                                            name="c_cash_status" // Ensure this matches the property name in your state
                                            value={abstractHomeSetup.c_cash_status || "0"}
                                            onChange={handleInput}>
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Confernce Free Status</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="ConfernceFree Status "
                                            name="c_free_status" // Ensure this matches the property name in your state
                                            value={abstractHomeSetup.c_free_status || "0"}
                                            onChange={handleInput}>
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Confernce Saudi Council Status</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Confernce Saudi Council Status "
                                            name="c_saudi_council_status" // Ensure this matches the property name in your state
                                            value={abstractHomeSetup.c_saudi_council_status || "0"}
                                            onChange={handleInput}>
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                {/* Single Banner Image Upload */}


                                <Grid item xs={6}>
                                    <label htmlFor="banner-upload">
                                        <TextField id="icon-button-file" type="file" onChange={(e) => setEventLogo(e.target.files[0])} name="[licenseFile]" />
                                        <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => document.getElementById('banner-upload').click()}>
                                            <PhotoCamera />
                                        </IconButton>
                                        Event Logo
                                    </label>
                                    <FormHelperText>
                                        {abstractHomeSetup.error_list?.eventLogo
                                            ? `${abstractHomeSetup.error_list.eventLogo} width=1920, height=1160`
                                            : ""}
                                    </FormHelperText>

                                    {/* {abstractBannerImage && (
                                        <div>
                                            <h4>Selected Banner:</h4>
                                            <p>{abstractBannerImage.name}</p>
                                        </div>
                                    )} */}

                                    <div>  {

                                        abstractHomeSetup.eventLogo === "no_image.jpg" ? "" :

                                            <img src={`${abstractHomeSetup.eventLogo}`} width="400" height="200" />

                                    }
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <label htmlFor="banner-upload">
                                        <TextField id="icon-button-file" type="file" onChange={(e) => setAbstractBannerImage(e.target.files[0])} name="[licenseFile]" />
                                        <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => document.getElementById('banner-upload').click()}>
                                            <PhotoCamera />
                                        </IconButton>
                                        Abstract Banner Image
                                    </label>
                                    <FormHelperText>
                                        {abstractHomeSetup.error_list?.abstractBannerImage
                                            ? `${abstractHomeSetup.error_list.abstractBannerImage} width=1920, height=1160`
                                            : ""}
                                    </FormHelperText>

                                    {/* {abstractBannerImage && (
                                        <div>
                                            <h4>Selected Banner:</h4>
                                            <p>{abstractBannerImage.name}</p>
                                        </div>
                                    )} */}

                                    <div>  {

                                        abstractHomeSetup.abstractBannerImage === "no_image.jpg" ? "" :

                                            <img src={`${abstractHomeSetup.abstractBannerImage}`} width="400" height="200" />

                                    }
                                    </div>
                                </Grid>

                                <Grid item xs={6}>
                                    <label htmlFor="banner-upload">
                                        <TextField id="icon-button-file" type="file" onChange={(e) => setWokshopBannerImage(e.target.files[0])} name="[licenseFile]" />
                                        <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => document.getElementById('banner-upload').click()}>
                                            <PhotoCamera />
                                        </IconButton>
                                        Workshop Banner Image
                                    </label>
                                    <FormHelperText>
                                        {abstractHomeSetup.error_list?.workshopBannerImage
                                            ? `${abstractHomeSetup.error_list.workshopBannerImage} width=1920, height=1160`
                                            : ""}
                                    </FormHelperText>

                                    {/* {abstractBannerImage && (
                                        <div>
                                            <h4>Selected Banner:</h4>
                                            <p>{abstractBannerImage.name}</p>
                                        </div>
                                    )} */}

                                    <div>  {

                                        abstractHomeSetup.image === "no_image.jpg" ? "" :

                                            <img src={`${abstractHomeSetup.workshopBannerImage}`} width="400" height="200" />

                                    }
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <label htmlFor="banner-upload">
                                        <TextField id="icon-button-file" type="file" onChange={(e) => setConfereceBannerImage(e.target.files[0])} name="[licenseFile]" />
                                        <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => document.getElementById('banner-upload').click()}>
                                            <PhotoCamera />
                                        </IconButton>
                                        Conference Banner Image
                                    </label>
                                    <FormHelperText>
                                        {abstractHomeSetup.error_list?.conferenceBannerImage
                                            ? `${abstractHomeSetup.error_list.conferenceBannerImage} width=1920, height=1160`
                                            : ""}
                                    </FormHelperText>

                                    {/* {abstractBannerImage && (
                                        <div>
                                            <h4>Selected Banner:</h4>
                                            <p>{abstractBannerImage.name}</p>
                                        </div>
                                    )} */}

                                    <div>  {

                                        abstractHomeSetup.image === "no_image.jpg" ? "" :

                                            <img src={`${abstractHomeSetup.conferenceBannerImage}`} width="400" height="200" />

                                    }
                                    </div>
                                </Grid>


                                <Grid item xs={6}>
                                    <label htmlFor="banner-upload">
                                        <TextField id="icon-button-file" type="file" onChange={(e) => setAbstractFooterImage(e.target.files[0])} name="[licenseFile]" />
                                        <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => document.getElementById('banner-upload').click()}>
                                            <PhotoCamera />
                                        </IconButton>
                                        Footer Image
                                    </label>

                                    {/* {abstractFooterImage && (
                                        <div>
                                            <h4>Selected Banner:</h4>
                                            <p>{abstractFooterImage.name}</p>
                                        </div>
                                    )} */}

                                    <div>
                                        {
                                            abstractHomeSetup.image === "no_image.jpg" ? "" :

                                                <img src={`${abstractHomeSetup.abstractFooterImage}`} width="400" height="200" />

                                        }
                                    </div>
                                </Grid>

                                {/* Multiple Sponsor Logos Upload */}
                                <Grid item xs={6}>
                                    <label htmlFor="logos-upload">
                                        {/* <TextField
                                            id="logos-upload"
                                            type="file"
                                            onChange={handleFileChange}
                                            inputProps={{ multiple: true }}
                                            style={{ display: 'none' }}
                                        /> */}
                                        <TextField id="icon-button-file" type="file" onChange={handleFileChange} name="[licenseFile]" inputProps={{ multiple: true }} />
                                        <IconButton color="primary" aria-label="upload pictures" component="span" onClick={() => document.getElementById('logos-upload').click()}>
                                            <PhotoCamera />
                                        </IconButton>
                                        Sponsor Logos
                                    </label>

                                    {abstractSponserLogos.length > 0 && (
                                        <div>
                                            <h4>Selected Logos:</h4>
                                            <ul style={{ listStyleType: 'none', padding: 0 }}>
                                                {abstractSponserLogos.map((logo, index) => (
                                                    <li key={index}>{logo.name}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}


                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                        {abstractSponserLogos.length > 0 && abstractSponserLogos[0] !== "no_image.jpg" && abstractSponserLogos.map((logo, index) => (
                                            <img
                                                key={index}
                                                src={`${abstractHomeSetup.base_url}/homepage/${logo}`}
                                                width="200"
                                                height="100"
                                                alt={`Sponsor Logo ${index + 1}`}
                                                style={{ margin: '5px' }}
                                            />
                                        ))}
                                    </div>
                                </Grid>


                            </Grid>
                            <Grid container justifyContent="flex-end">
                                <Button
                                    disabled={disabled}
                                    type="submit"
                                    // fullWidth
                                    variant="contained"
                                    sx={{ mt: 5, backgroundColor: '#145348' }} >
                                    Submit
                                </Button>

                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
}

export default AbstractHomePAgeSettings;
